import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import BookAppointment from './pages/BookAppointment';
import AiIntakeChat from './pages/AiIntakeChat';
import ReferralForm from './pages/ReferralForm';
import Payment from './pages/Payment';
import PaypalReturn from './pages/PaypalReturn';
import PaypalCancel from './pages/PaypalCancel';
import VideoSession from './pages/VideoSession';
import PatientDashboard from './pages/PatientDashboard';
import ClinicianDashboard from './pages/ClinicianDashboard';
import AdminDashboard from './pages/AdminDashboard';
import PartnerDashboard from './pages/PartnerDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Courses from './pages/Courses';
import CertificateVerification from './pages/CertificateVerification';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/book" element={<BookAppointment />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:slug" element={<Courses />} />
          <Route path="/certificate/:token" element={<CertificateVerification />} />
          <Route path="/refer" element={<ReferralForm />} />
          <Route path="/pay/:appointmentId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/pay/course/:courseId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/paypal/return" element={<ProtectedRoute><PaypalReturn /></ProtectedRoute>} />
          <Route path="/paypal/cancel" element={<ProtectedRoute><PaypalCancel /></ProtectedRoute>} />
          <Route path="/session/:appointmentId" element={<ProtectedRoute><VideoSession /></ProtectedRoute>} />

          <Route
            path="/intake/:appointmentId"
            element={<ProtectedRoute allowedRoles={['patient']}><AiIntakeChat /></ProtectedRoute>}
          />
          <Route
            path="/dashboard"
            element={<ProtectedRoute allowedRoles={['patient']}><PatientDashboard /></ProtectedRoute>}
          />
          <Route
            path="/clinician"
            element={<ProtectedRoute allowedRoles={['clinician']}><ClinicianDashboard /></ProtectedRoute>}
          />
          <Route
            path="/admin"
            element={<ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>}
          />
          <Route
            path="/partner"
            element={<ProtectedRoute allowedRoles={['referral_partner']}><PartnerDashboard /></ProtectedRoute>}
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function NotFound() {
  return (
    <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
      <h1>Page not found</h1>
      <p>The page you're looking for doesn't exist.</p>
    </div>
  );
}
